'use strict';

var storelocator = require('./linchpin/storelocator'),
	contactus = require('./linchpin/contactus'),
	product = require('./linchpin/product'),
	subscription = require('./linchpin/subscription'),
	search = require('./linchpin/search'),
	compare = require('./linchpin/compare'),
	impressions = require('./linchpin/impressions'),
	storefront = require('./linchpin/storefront');

/**
 * Events are divided up by name space so only the
 * events that are needed are initialized.
 */
var events = {
	account: function () {},
	cart: function () {},
	checkout: function () {},
	contactus: function () {
		// click on the "Telephone & Email" section
		contactus.initContactDirectTracker();
		// click on the "Addresses" section
		contactus.initContactAddressTracker();
		// clicks on email on the "Telephone & Email" section
		contactus.initContactEmailTracker();
		// click on question on the FAQ
		contactus.initContactFaqTracker();
	},
	hampers: function () {},
	compare: function () {
		// click on PRINT YOUR COMPARISON link
		compare.initPrintComparison();
		// click on details tab
		compare.initCompareDetails();
		// click on ingredients tab
		compare.initCompareIngredients();
	},
	product: function () {
		// switch between product images
		product.initProductViewGalleryTracker();
		// click on product tabs (description/reviews, etc)
		product.initProductDetailsTracker();
		// click on product ingredients tab
		product.initProductIngredientsTracker();
		// click on product reviews tab
		product.initProductReviewsTracker();
		// adding a tasting experience to the bag
		product.initTastingExAddToBagTracker();
		// adding a recipe to the bag
		product.initRecipeBagTracker();
		// adding a gift cart to the bag
		product.initGiftcardAddToBagTracker();
		// adding product to the bag by click on 'order via click & collect' button
		product.initClickAndCollectTracker();
		// click on 'Add to wishlist' link
		product.initAddToWishlistTracker();
		// click to submit 'Drop a Hint' form
		product.initDropAHintTracker();
	},
	search: function () {
		// re-init tab events on quickview when change variants
		product.initQuickViewTabEvents();
		if ($('input[name=searchPhrase]').length > 0) {
			// change of sorting option (search)
			search.initSearchSortEvent();
			// click on grid/list view icons (search)
			search.initSearchViewEvent();
			search.initSearchResultsEvent();
		} else {
			// change of sorting option (category)
			search.initCategorySortEvent();
			// click on grid/list view icons (category)
			search.initCategoryViewEvent();
			// click on compare checkbox (category)
			search.initAddToCompareEvent();
		}
	},
	storefront: function () {},
	storelocator: function () {
		// map/list view tabs clicks on store locator landing page
		storelocator.initVieweSelectionTracker();
		// click on Get Directions button on store details page
		storelocator.initStoreDirectionsTracker();
	},
	wishlist: function () {},
	// events that should happen on every page
	all: function () {
		impressions.promoBannerImpression();
		storefront.pageLoadEvent();
		setInterval (function () {
			impressions.trackImpressions();
		}, 1500);
	},
	ordergroove: function () {
		// change of the product flavour
		subscription.initOrderFlavourChangeEvent();
		// change of the product quantity
		subscription.initOrderQuantityChangeEvent();
		// change of the subscription frequency
		subscription.initOrderFrequencyChangeEvent();
		// click on the "Edit address" link
		subscription.initAddressClickEvent();
		// click on "Cancel Subscription" button
		subscription.initCancelSubscriptionConfirmEvent();
		// click on "Billing Details" button
		subscription.initBillingDetailsClickEvent();
	},
	wallet: function () {
		// click on "Make Default" button
		subscription.initBillingDetailsCardChangeEvent();
	}
};

/**
 * @function init
 * @description Initialize the tag manager functionality
 * @param {String} nameSpace The current name space
 */
exports.init = function (nameSpace) {
	if (nameSpace && events[nameSpace]) {
		events[nameSpace]();
	}
	events.all();
};
